import { head } from '../../../../utils/helper/lodash_replacements';
export class AspectEventLatest {
    parent;
    constructor(parent) {
        this.parent = parent;
    }
    get aspectEvent() {
        return this.parent;
    }
    get aspect() {
        return this.aspectEvent.aspect;
    }
    get latestEventProxy() {
        return new ObservedLatestEvent(this);
    }
}
class ObservedLatestEvent {
    constructor(parent) {
        return new Proxy(parent, this);
    }
    get(parent, eventKey) {
        return head(parent.aspectEvent.eventsOfType(eventKey));
    }
}
